import React from 'react';
import { AegisRIA } from './components/AegisRIA';
export function App() {
  return <AegisRIA data-id="element-0" />;
}